import React__default from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import icons from '../../assets/icons/index.js';
import getInkColour from '../../utils/getInkColour.js';
import { ICON_SIZES } from '../../constants/sizes.js';
import Loader from '../Loader/index.js';
import { LOADING_ICON } from './Icon.constants.js';

var VARIANTS = Object.keys(icons);
var STROKE_WIDTH = '7.5%';
var POS_X_1 = '20%';
var POS_X_2 = '120%';
var VIEW_BOX_SIZE = 24;
var Icon = function Icon(_ref) {
  var _ref$colour = _ref.colour,
    colour = _ref$colour === void 0 ? undefined : _ref$colour,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$off = _ref.off,
    off = _ref$off === void 0 ? false : _ref$off,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    variant = _ref.variant,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var SVG = icons[variant];
  var loadingVariant = variant === LOADING_ICON;
  if (!SVG && !loadingVariant) {
    throw new Error("We do not have an SVG for ".concat(variant, "."));
  }
  var theme = useTheme();
  var fill = colour ? getInkColour(theme, colour) : 'currentColor';
  var iconSize = ICON_SIZES[size];
  var maskId = "".concat(variant, "-mask");
  if (loadingVariant) return React__default.createElement(Loader, {
    colour: fill,
    size: iconSize
  });
  return React__default.createElement("svg", {
    height: iconSize,
    id: id,
    style: {
      fill: fill
    },
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE),
    width: iconSize,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": testId
  }, off && React__default.createElement("defs", null, React__default.createElement("mask", {
    id: maskId
  }, React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: VIEW_BOX_SIZE,
    height: VIEW_BOX_SIZE,
    fill: "white"
  }), React__default.createElement("line", {
    stroke: "black",
    strokeWidth: STROKE_WIDTH,
    x1: POS_X_1,
    x2: POS_X_2,
    y1: "-".concat(STROKE_WIDTH),
    y2: "-".concat(STROKE_WIDTH),
    transform: "rotate(45)"
  }))), React__default.createElement("g", null, off && React__default.createElement("line", {
    stroke: fill,
    strokeWidth: STROKE_WIDTH,
    x1: POS_X_1,
    x2: POS_X_2,
    transform: "rotate(45)"
  }), React__default.createElement(SVG, {
    style: {
      fill: fill,
      mask: off ? "url(#".concat(maskId, ")") : undefined
    }
  })));
};
Icon.propTypes = {
  colour: PropTypes.string,
  id: PropTypes.string,
  off: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(ICON_SIZES)),
  testId: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS).isRequired
};

export { Icon, VARIANTS };
//# sourceMappingURL=Icon.js.map
